import React from 'react'
import styled from 'styled-components'
import { ELEMENT_TYPES } from 'cg/components/documents/editor/slate/types'

const AppLink = ({ attributes, children, element, themeColor, username, workspacePath, publishedDocument }) => {
  const {
    type,
    title,
    link_without_namespace_and_workspace,
    publish_link,
    publish_absolute_link,
    publish_display_link,
    absolute_link
  } = element
  const link = `/${username}/${workspacePath}${link_without_namespace_and_workspace}`

  return (
    <div {...attributes}>
      <div contentEditable={false}>
        <LinkContentWrapper>
          <LinkIconWrapper themeColor={themeColor}>
            {type === ELEMENT_TYPES.issuelink && <i className="far fa-objects-align-top" />}
            {type === ELEMENT_TYPES.mrlink && <i className="far fa-code-pull-request" />}
            {type === ELEMENT_TYPES.commitlink && <i className="far fa-code-commit" />}
            {type === ELEMENT_TYPES.documentlink && <i className="far fa-file-contract" />}
          </LinkIconWrapper>
          <LinkTitleWrapper>
            <LinkTitle themeColor={themeColor}>
              <Link
                href={publishedDocument ? publish_absolute_link || absolute_link : link}
                target="_blank"
                themeColor={themeColor}
              >
                {title}
              </Link>
            </LinkTitle>
          </LinkTitleWrapper>
        </LinkContentWrapper>
        {children}
      </div>
    </div>
  )
}

export default AppLink

const LinkContentWrapper = styled.div`
  display: flex;
  border-radius: 3px;
  border: 1px solid ${props => props.theme.borderColor};

  width: 100%;
  background-color: ${props => props.theme.bgSecondLightest};
  margin: 15px 0px;
  color: ${props => props.theme.textGreyTinted};
`
const LinkTitleWrapper = styled.div`
  flex: 1 1 auto;
  min-width: 1px;
  text-align: left;
  padding-left: 0px;
  padding-right: 10px;
  flex-grow: 1;
  padding: 10px;
`
const LinkIconWrapper = styled.div`
  font-size: 16px;
  min-height: 100%;
  background: red;
  display: flex;
  min-width: 40px;
  align-items: center;
  justify-content: center;
  border-right: 1px solid ${props => props.theme.borderColor};
  background: ${props => props.theme.hoverBgLightestInverse};
  color: ${props => (props.themeColor ? props.themeColor : props.theme.primary)};
`

const LinkTitle = styled.div`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
`

const Link = styled.a`
  color: ${props => props.theme.textGreyTinted};
  :hover {
    color: ${props => (props.themeColor ? props.themeColor : props.theme.primary)};
    text-decoration: underline;
  }
`
